/**
 * sl-9qm.6.1: UnknownComponentPlaceholder — Fallback for unregistered component types
 *
 * Shown when ViewConfig references a componentType not in the ComponentRegistry.
 * This can happen when a component is removed from the registry but still in config.
 *
 * SOLID:
 * - S: Only placeholder display
 */
import { createElement, type FC } from 'react';

import * as styles from './styles.css';

interface UnknownComponentPlaceholderProps {
  componentType: string;
}

export const UnknownComponentPlaceholder: FC<
  UnknownComponentPlaceholderProps
> = ({ componentType }) => {
  return createElement(
    'div',
    { className: styles.unknownPlaceholder },
    `Unknown component: "${componentType}"`
  );
};
